export default function createNodeId(id: number | string, type: string) {
  return `${type}_${id}`;
}
